import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TechMarquee } from "@/components/site/TechMarquee";
import { About } from "@/components/site/About";
import { Solutions } from "@/components/site/Solutions";
import { TechExpertise } from "@/components/site/TechExpertise";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Industries } from "@/components/site/Industries";
import { Pricing } from "@/components/site/Pricing";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    if (window.__DISABLE_LENIS__) return;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" />
      <Toaster theme="dark" position="bottom-right" richColors />
      <Navbar />
      <main>
        <Hero />
        <TechMarquee />
        <About />
        <Solutions />
        <TechExpertise />
        <WhyChoose />
        <Industries />
        <Pricing />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
